document.addEventListener('DOMContentLoaded', function () {
  new Swiper(".mySwiper", {
    loop: true,
    spaceBetween: 24,
    slidesPerView: 5, // Default: 1025px and above
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    breakpoints: {
      0: {
        slidesPerView: 1.5 // Up to 767px
      },
      768: {
        slidesPerView: 3 // 768px to 1024px
      },
      1025: {
        slidesPerView: 5 // 1025px and above
      }
    }
  });
});

